// extracted by mini-css-extract-plugin
module.exports = {"box":"SearchBar_box__11xCY","link":"SearchBar_link__2Pvm1"};